<template>
    <CModal
        :title="titleComponent"
        :show="showComponent"
        :color="colorComponent"
        :size="sizeComponent"
    >
        <CForm
            ref="formSendToDeliveryCampaign"
            @submit="submitForm($event, 'formSendToDeliveryCampaign')"
        >
            <SelectAsync
                :placeholder="$t('Select a campaign')"
                :optionsValue="'id'"
                :optionsLabel="'name'"
                size="sm"
                endpoint="campaigns.api"
                :isValid="
                    checkIfFormValid({
                        formName: 'formSendToDeliveryCampaign',
                        fieldName: 'campaign_id',
                    })
                "
                :value.sync="
                    $v.forms.formSendToDeliveryCampaign['campaign_id'].$model
                "
            />

            <div class="form-group form-row">
                <label class="col-form-label col-sm-3 col-form-label-sm">{{
                    $t("Force sending")
                }}</label>
                <div class="col-sm-9">
                    <CSwitch
                        :checked.sync="
                            $v.forms.formSendToDeliveryCampaign['force_send']
                                .$model
                        "
                        color="primary"
                        name="action"
                        shape="pill"
                        variant="3d"
                        size="sm"
                    />
                </div>
            </div>

            <CInputCheckbox
                :checked.sync="
                    $v.forms.formSendToDeliveryCampaign[
                        'accepted_consent_policies'
                    ].$model
                "
                :label="$t('I confirm that I accept the consent policies')"
                :isValid="
                    checkIfFormValid({
                        formName: 'formSendToDeliveryCampaign',
                        fieldName: 'accepted_consent_policies',
                    })
                "
                :invalidFeedback="$t('It is necessary to accept the policies')"
            />

            <br />

            <ButtonLoading
                type="submit"
                :block="true"
                color="primary"
                :loading="forms.formSendToDeliveryCampaign._loading"
            >
                <span>{{ $t("send") }}</span>
            </ButtonLoading>
        </CForm>
        <template #footer>
            <CButton color="secondary" @click="closeModal()">
                {{ $t("cancel") }}
            </CButton>
            <ButtonLoading
                color="primary"
                @click="executeSubmitForm('formSendToDeliveryCampaign')"
                :loading="forms.formSendToDeliveryCampaign._loading"
            >
                {{ $t("send") }}
            </ButtonLoading>
        </template>
    </CModal>
</template>

<script>
/** Components */
import SelectAsync from "~/components/elements/SelectAsync.vue";
import ButtonLoading from "~/components/ButtonLoading.vue";

/** Mixins */
import formMixin from "~/mixins/form";
import modalComponentMixin from "~/mixins/modalComponent";

/** Others */
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";
export default {
    name: "SendLeadsToDeliveryCampaignModal",
    mixins: [formMixin, validationMixin, modalComponentMixin],
    components: {
        SelectAsync,
        ButtonLoading,
    },
    data() {
        return {
            forms: {
                formSendToDeliveryCampaign: {
                    campaign_id: null,
                    force_send: false,
                    accepted_consent_policies: false,
                    _loading: false,
                },
            },

            provider: null,
        };
    },
    props: {
        leads: {
            type: Array,
            required: true,
        },
    },
    validations: {
        forms: {
            formSendToDeliveryCampaign: {
                campaign_id: {
                    required,
                },
                force_send: {
                    required,
                },
                accepted_consent_policies: {
                    required,
                },
            },
        },
    },

    watch: {
        show() {
            this.showComponent = this.show;
        },

        showComponent() {
            if (!this.showComponent) {
                this.resetForms();
                this.$v.forms.formSendToDeliveryCampaign.$reset();
            }
        },
        dataComponent() {
            if (this.dataComponent.provider)
                this.provider = this.dataComponent.provider;
        },
    },

    methods: {
        async submitForm(e, formName) {
            e.preventDefault();
            this.$v.forms.formSendToDeliveryCampaign.$touch();
            try {
                if (this.$v.forms.formSendToDeliveryCampaign.$invalid) {
                    throw { code: 422, message: this.$t("Invalid data") };
                }

                this.forms.formSendToDeliveryCampaign._loading = true;

                await this.fetcher({
                    url: `/campaigns.api/${this.forms[formName].campaign_id}/leads/send`,
                    method: "PUT",
                    data: {
                        list_ids: this.leads.map((lead) => lead.id),
                        force_send: this.forms[formName].force_send,
                        accepted_consent_policies:
                            this.forms[formName].accepted_consent_policies,
                    },
                });

                this.showMessageSuccess();
                this.showComponent = false;

                this.$emit("submit", formName);
            } catch (error) {
                this.showMessageError(error);
            } finally {
                this.forms.formSendToDeliveryCampaign._loading = false;
            }
        },
        resetForm(formName) {
            let form = this.getForm(formName);
            for (const key in form) {
                if (Object.hasOwnProperty.call(form, key)) {
                    if (typeof form[key] === "boolean") {
                        form[key] = false;
                    } else {
                        form[key] = null;
                    }
                }
            }
            return form;
        },
    },
};
</script>
